(() => {
  const clamp = (value, min, max) =>
    Math.min(Math.max(value, min), max);

  class ProductGalleryLightbox {
    constructor(modal) {
      this.modal = modal;
      this.content = modal.querySelector(
        '.product-media-modal__content'
      );

      this.items = Array.from(this.content?.children || []).filter(
        (item) =>
          !item.classList.contains('product-media-modal__toolbar')
      );

      this.counter = modal.querySelector(
        '[data-lightbox-counter]'
      );

      this.zoomLevel = 1;
      this.activeIndex = 0;

      if (!this.content || !this.items.length) return;

      this.items.forEach((item, index) => {
        item.classList.add('product-media-modal__item');
        item.dataset.lightboxIndex = index;
      });

      modal
        .querySelector('[data-lightbox-prev]')
        ?.addEventListener('click', () => {
          this.show(this.activeIndex - 1);
        });

      modal
        .querySelector('[data-lightbox-next]')
        ?.addEventListener('click', () => {
          this.show(this.activeIndex + 1);
        });

      modal
        .querySelector('[data-lightbox-zoom-in]')
        ?.addEventListener('click', () => {
          this.setZoom(this.zoomLevel + 0.5);
        });

      modal
        .querySelector('[data-lightbox-zoom-out]')
        ?.addEventListener('click', () => {
          this.setZoom(this.zoomLevel - 0.5);
        });

      modal.addEventListener('click', (event) => {
        const image = event.target.closest(
          '.product-media-modal__item.active img'
        );

        if (image) {
          this.setZoom(this.zoomLevel === 1 ? 2 : 1);
        }
      });

      document.addEventListener('keydown', (event) => {
        if (!modal.hasAttribute('open')) return;

        if (event.key === 'ArrowLeft') {
          this.show(this.activeIndex - 1);
        }

        if (event.key === 'ArrowRight') {
          this.show(this.activeIndex + 1);
        }

        if (event.key === '+' || event.key === '=') {
          this.setZoom(this.zoomLevel + 0.5);
        }

        if (event.key === '-') {
          this.setZoom(this.zoomLevel - 0.5);
        }
      });

      const observer = new MutationObserver(() => {
        if (!modal.hasAttribute('open')) return;

        const opener = modal.openedBy;
        const mediaId = opener?.dataset.mediaId;

        const index = this.items.findIndex(
          (item) =>
            String(item.dataset.mediaId) === String(mediaId)
        );

        this.show(index >= 0 ? index : 0);
      });

      observer.observe(modal, {
        attributes: true,
        attributeFilter: ['open']
      });
    }

    show(index) {
      this.activeIndex =
        (index + this.items.length) % this.items.length;

      this.items.forEach((item, itemIndex) => {
        item.classList.toggle(
          'active',
          itemIndex === this.activeIndex
        );
      });

      this.setZoom(1);

      if (this.counter) {
        this.counter.textContent =
          `${this.activeIndex + 1} / ${this.items.length}`;
      }

      this.items[this.activeIndex]?.scrollIntoView({
        block: 'center',
        inline: 'center'
      });
    }

    setZoom(level) {
      this.zoomLevel = clamp(level, 1, 3);

      const activeItem = this.items[this.activeIndex];
      const image = activeItem?.querySelector('img');

      this.modal.dataset.zoomed =
        this.zoomLevel > 1 ? 'true' : 'false';

      if (image) {
        image.style.transform =
          `scale(${this.zoomLevel})`;

        image.style.cursor =
          this.zoomLevel > 1 ? 'zoom-out' : 'zoom-in';
      }
    }
  }

  const initialize = (root = document) => {
    root
      .querySelectorAll(
        'product-modal.product-media-modal:not([data-lightbox-ready])'
      )
      .forEach((modal) => {
        modal.dataset.lightboxReady = 'true';
        new ProductGalleryLightbox(modal);
      });

    root.querySelectorAll('.js-media-sublist').forEach(
      (slider) => {
        const syncHeight = () => {
          if (window.innerWidth < 1100) {
            slider.style.removeProperty(
              '--product-thumbnail-height'
            );
            return;
          }

          const main = slider
            .closest('.product__media-list-wrapper')
            ?.querySelector('.js-media-list');

          if (main) {
            slider.style.setProperty(
              '--product-thumbnail-height',
              `${main.getBoundingClientRect().height}px`
            );
          }
        };

        syncHeight();

        new ResizeObserver(syncHeight).observe(
          slider.closest('.product__media-list-wrapper') ||
            slider
        );
      }
    );
  };

  document.addEventListener('DOMContentLoaded', () => {
    initialize();
  });

  document.addEventListener(
    'shopify:section:load',
    (event) => {
      initialize(event.target);
    }
  );
})();